import React from "react"
import classes from "./grid.module.css"
import Single from "./single/single"
import image1 from "../../images/semiperm1.jpg"
import image2 from "../../images/face_600x400.jpg"
import image3 from "../../images/laser1.jpg"

const grid = props => {
  return (
    <div className={classes.Grid}>
      <Single
        title="Semi permanent make-up"
        image={image1}
        link="/semi-permanent-make-up"
      />
      <Single
        title="Laser hair removal"
        image={image3}
        link="/laser-hair-removal"
      />
      <Single title="Facials" image={image2} link="/facials" />
    </div>
  )
}

export default grid
